// Footing quality: 1–10 rating of how easy a segment is underfoot.
// 10 = anyone could walk it easily; 1 = challenging for horses and people.
// A property of the trail, not the weather. Volunteers and above only.

// Red (1) through green (10). Mid-scale is a darker amber than the usual
// yellow so it stays visible on the light street map.
const FOOTING_COLORS = [
  '#a50026', '#d73027', '#f46d43', '#f08c39', '#d9a21b',
  '#b5b82a', '#8cbf4a', '#5aa850', '#1f8f4d', '#006837',
];
export const FOOTING_UNRATED_COLOR = '#adb5bd';

export function footingColor(score) {
  const n = Number(score);
  return Number.isInteger(n) && n >= 1 && n <= 10 ? FOOTING_COLORS[n - 1] : FOOTING_UNRATED_COLOR;
}

export function footingDescription(score) {
  const n = Number(score);
  if (!Number.isInteger(n) || n < 1) return 'Not rated';
  if (n >= 9) return 'Easy footing';
  if (n >= 7) return 'Good footing';
  if (n >= 5) return 'Fair footing';
  if (n >= 3) return 'Rough footing';
  return 'Challenging footing';
}

// Legend bands, best first.
export const FOOTING_BANDS = [
  { label: '9–10 easy', score: 10 },
  { label: '7–8 good', score: 8 },
  { label: '5–6 fair', score: 5 },
  { label: '3–4 rough', score: 3 },
  { label: '1–2 challenging', score: 1 },
];

export const FOOTING_SCORES = [10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
